import { useMemo } from 'react';
import { useIsHeaderCollapsed } from '../../store/campaignsStore';
import { useViewMode } from '../../../../store/app/appStore';

export const useCampaignCollapsedState = () => {
  const isCollapsed = useIsHeaderCollapsed();
  const viewMode = useViewMode();

  const collapsedAttributes = useMemo(
    () => ({ 
      'data-collapsed': isCollapsed ? 'true' : 'false',
      'data-view': viewMode
    }),
    [isCollapsed, viewMode]
  );

  const getCollapsedClassName = useMemo(() => {
    return (baseClassName: string, collapsedClassName?: string): string => {
      if (!isCollapsed || !collapsedClassName) return baseClassName;
      return `${baseClassName} ${collapsedClassName}`;
    };
  }, [isCollapsed]);

  return {
    isCollapsed,
    collapsedAttributes,
    getCollapsedClassName,
  };
};
